/* eslint-disable jira/filename-case */
import { jiraSuperBatchDependencies } from './constants.tsx';

let isSuperBatchDependenciesLoaded = false;

const isOnRapidBoardsPage = () => {
	const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
	const backlogsRegex =
		/\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const { pathname } = window.location;
	return (
		boardsRegex.test(pathname) ||
		backlogsRegex.test(pathname) ||
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.location.href.includes('secure/RapidBoard.jspa')
	);
};

export const prependSuperBatchDepsOnce = (wrmKeys: string | string[]): string | string[] => {
	// These usually need injecting before most domain-specific deps but in rapidboards they load a
	// smaller set of the needed deps internally early and delay the rest
	if (isSuperBatchDependenciesLoaded || isOnRapidBoardsPage()) {
		return wrmKeys;
	}

	isSuperBatchDependenciesLoaded = true;
	return jiraSuperBatchDependencies.concat(wrmKeys);
};
